import * as React from "react";

const Card = ({ title, imageSrc, redirectTo, style, imageSize }) => {
    return (
        <div className="flex flex-col grow justify-center items-center w-full text-3xl font-semibold text-black uppercase bg-white rounded-lg shadow-lg leading-[50px] max-md:max-w-full" style={{ ...style }}>
            <a target="_blank" href={redirectTo} >
                <img
                    src={imageSrc}
                    alt={title}
                    className={`max-w-full ${imageSize}`}
                />
            </a>
        </div>
    );
};

const Content3 = () => {
    const cardData = [
        {
            name: "UN Global Compact",
            imageSrc: "/assets/images/membership/un-g.jpg",
            website: "https://wtca.org/",
            style: {
                background: '#FFF',
                aspectRatio: "5.26/2",
                padding: "2rem",
            },
            imageSize: "h-[150px] w-full"
        }
    ]


    return (
        <section className="w-full mt-2 max-md:max-w-full">
            <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div className="grid w-full grid-cols-1 gap-8 md:grid-cols-2">
                    {cardData.map(card => <Card {...card} />)}
                </div>
            </div>
        </section>
    );
};

export default Content3;
